import React, { useEffect, useState } from 'react';
import { DateField, InputField, SelectField } from 'vetrf-ui';
import { BYTE_MAX_LENGTH } from 'utils/consts/consts';
import { DocumentDictOption } from 'api/dict/params';
import { dictApi } from 'api/dict';

type DocumentFieldsProps = {
  required?: boolean;
  defaultDocumentType?: string;
  withNumber?: boolean;
};

export const DocumentFields = ({
  required,
  defaultDocumentType,
  withNumber = true,
}: DocumentFieldsProps) => {
  const [documentTypeOptions, setDocumentTypeOptions] = useState<DocumentDictOption[]>([]);

  const getDocumentTypeOptions = async () => {
    const res = await dictApi.getDocumentTypes();
    setDocumentTypeOptions(res);
  };

  useEffect(() => {
    getDocumentTypeOptions();
  }, []);

  return (
    <>
      <SelectField
        labelText="Тип документа"
        defaultValue={
          defaultDocumentType
            ? documentTypeOptions.find((item) => item.name === defaultDocumentType)
            : undefined
        }
        name="documentType"
        labelKey="name"
        valueKey="id"
        required={required && 'Необходимо заполнить поле'}
        options={documentTypeOptions}
      />
      {withNumber && (
        <InputField
          labelText="Номер документа"
          name="documentNumber"
          maxLength={BYTE_MAX_LENGTH}
          required={required && 'Необходимо заполнить поле'}
        />
      )}
      <DateField
        dateFormat="dd.MM.yyyy"
        labelText="Дата документа"
        locale="ru"
        name="documentDate"
        required={required && 'Необходимо заполнить поле'}
        validateDateFormat
        comparisonWithCurrentDate={{ methodOfComparison: 'isSameOrBefore' }}
      />
    </>
  );
};
